import { render, staticRenderFns } from "./pageMovingComponent.vue?vue&type=template&id=b7028538&"
import script from "./pageMovingComponent.vue?vue&type=script&lang=js&"
export * from "./pageMovingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports